import type { FieldRegistryItem } from '../field-types'
import TextEntitySidebar from './text/TextEntitySidebar.vue'
import TextField from './text/TextField.vue'

export const textField = {
  field: TextField,
  entitySidebar: TextEntitySidebar,
} as FieldRegistryItem<'text'>
